<template>
  <div id="pageRoot">
    <img id="bg" src="/pages/img/sordocas/svgCas36bg.svg" />

    <p class="textBase hover-animation-c appearAnimationA" id="tag01">
      LA MAYORÍA DE LOS CASTILLOS ESTÁN DESHABILITADOS
    </p>
    <p class="textBase appearAnimationB" id="text02">ES LO MISMO QUE DECIR</p>

    <label class="toggleButtonContainer pageElement" id="toggle01"
      >EN LA MAYORÍA DE LOS CASTILLOS <br />NO VIVE NADIE.
      <input type="radio"
        name="castillos"
        ref="1-1" 
        v-on:change="saveOption('radios', 1, 1)" 
        :onload="loadOption('radios', 1, 1)"/>
      <span class="toggleButton"></span>
    </label>
    <label class="toggleButtonContainer pageElement" id="toggle02"
      >EN LA MAYORÍA DE LOS CASTILLOS <br />VIVE MUCHA GENTE.
      <input type="radio"
        name="castillos"
        ref="1-2" 
        v-on:change="saveOption('radios', 1, 2)" 
        :onload="loadOption('radios', 1, 2)"/>
      <span class="toggleButton"></span>
    </label>
  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 120px;
  top: 220px;
}

#tag01 {
  position: absolute;
  width: 790px;
  height: 50px;
  left: 70px;
  top: 123px;
  text-align: center;
  background-color: #00a5a5;
  font-style: italic;
  font-weight: normal;
  font-size: 29px;
  line-height: 45px;
  color: #ffffff;
}
#text02 {
  position: absolute;
  left: 69px;
  top: 192px;
  font-size: 30px;
  line-height: 41px;
  color: #00a5a5;
}
label {
  font-style: italic;
  text-transform: uppercase;
  font-size: 29px;
}
#toggle01 {
  position: absolute;
  left: 65px;
  top: 272px;
}
#toggle02 {
  position: absolute;
  left: 65px;
  top: 359px;
}
</style>
<script>
  export default {
    methods:{
      dbId(name, group){
        return `${this.$parent.pageID()}-${name}-${group}`
      },
      async loadOption(name, group, option) {
        var id = this.dbId(name, group);

        var value = await this.$db.options.get({
        id: id,
        }).catch(function(error){
        console.log("error getting option" + error);
        });
        if (value === undefined) return;
        console.log(value);

        this.$refs[group+"-"+option].checked=value.option==option;

        console.log("option loaded: " + id + ", option:" + option + ", selected:" + value.option);
      },
      saveOption(name, group, option) {
        var id = this.dbId(name, group);

        this.$db.options.put({
              id: id,
              option: option
          }).catch(function(error){
              console.log("error saving option" + error);
          });

        console.log("option saved: " + id + ", " + option);
      }
    }
  }
</script>